// extracted by mini-css-extract-plugin
module.exports = {"add-diagnose":"add-diagnose___3qpNy","diagnose-plus":"diagnose-plus___1NZAq","primary":"primary___11ud4"};